import { put, takeEvery } from 'redux-saga/effects';
import pick from 'lodash/pick';

import { types, STORAGE_KEY } from '../actions';
import { saveItem } from '../utilities/localStorage';

// Update Options
function* updateOptions({ payload }) {
  try {
    saveItem(STORAGE_KEY, {
      ...pick(payload, ['formatting', 'polling', 'sort'])
    });

    yield put({ type: types.UPDATE_OPTIONS_SUCCESS, payload });
  } catch(e) {
    console.error(e);
  }
}

function* optionsSaga() {
  yield takeEvery(types.UPDATE_OPTIONS, updateOptions);
}

export default optionsSaga;



// WEBPACK FOOTER //
// ./src/sagas/AppSaga.js